<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">
        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="px-2 py-3">
                <app-header icon="factory" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Détenteurs</h1>
                    </div>
                </app-header>
                <!-- Action principale (garde id=main-action pour le JS) -->
                <action-bar :back="{ name: 'home' }" class="!p-0  mb-2">
                    <router-link :to="{ name: 'new-detenteur' }"
                    class="bg-white transition px-4 py-2 rounded-lg text-primary text-sm font-medium" id="main-action"
                    @click.native.prevent="checkCanEdit('new-detenteur')">
                    Ajouter
                </router-link>
                </action-bar>

                <!-- Section recherche -->
                <div>
                    <filter-bar @searchBarChanged="updateSearch"
                        placeholderFilter="Rechercher par numéro, raison sociale…" class="block pb-5" type-history="detenteur" />
                </div>
            </div>
        </div>


        <!-- Corps -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <!-- Sync info -->
            <div v-if="asyncDetenteurs === true" class="px-4 pt-3">
                <div
                    class="flex items-center gap-2 text-sm text-gray-600 bg-white/70 backdrop-blur rounded-lg px-3 py-2 shadow">
                    <img class="h-4 w-4" src="../../img/spinner-load.gif" alt="" />
                    <span>Synchronisation en cours en arrière plan</span>
                </div>
            </div>

            <!-- Liste -->
            <div id="detenteurs-items" class="mx-1 my-2 shadow-2xl rounded-lg overflow-hidden bg-white">
                <detenteur-item v-for="detenteur in paginatedList" :key="detenteur.id" :detenteur="detenteur"
                    :typeuser="typeUser" class="border-b last:border-b-0" />
            </div>

            <!-- Pagination -->
            <div class="px-4 pb-6 mt-2 flex items-center justify-between gap-3">
                <button @click="previousPage" v-show="paginator.showPreviousButton && !strSearch"
                    class="px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm hover:bg-gray-50">
                    Page précédente
                </button>
                <div class="flex-1"></div>
                <button @click="nextPage" v-show="paginator.showNextButton && !strSearch"
                    class="px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm hover:bg-gray-50">
                    Page suivante
                </button>
            </div>
        </main>
    </main-layout>
</template>

<script>
import DetenteurItem from './DetenteurItem.vue'
import Detenteur from '../../js/models/Detenteur'
import History from '../../js/core/History'

export default {
    data() {
        return {
            dets: [],
            strSearch: '',
            detenteurs: [],
            canEditDetenteurs: true,
            typeUser: localStorage.getItem('typeUser'),
            paginator: {
                currentPage: 1,
                pageSize: 70,
                showPreviousButton: false,
                showNextButton: false,
            },
            // asyncDetenteurs en string.. car localStorage ne prend que des strings
            asyncDetenteurs: localStorage.getItem('asyncDetenteurs') === 'true',
        }
    },
    methods: {
        updateSearch(str) {
            if (str[0].length >= 2) {
                this.strSearch = this.normalize(String(str[0]))
            } else if (str[0].length === 0) {
                this.strSearch = ''
            }
        },

        fetchDetenteurs() {
            Detenteur.getList().then((data) => {
                this.detenteurs = _.sortBy(data, [
                    (det) => {
                        if (det.raison_sociale) {
                            return det.raison_sociale.toUpperCase();
                        } else {
                            return ''; // Retourne une chaîne vide si raison_sociale est undefined
                        }
                    },
                ]);
                this.updatePaginator();
            });
        },


        checkCanEdit(e) {
            if (JSON.parse(localStorage.getItem('canEditDetenteurs')) === true) {
                this.$router.push(e)
            } else {
                swal(
                    'Action non autorisée',
                    "Vous n'avez pas le droit d'ajouter de détenteurs, veuillez contacter votre administrateur",
                    'error'
                )
            }
        },

        normalize(s) {
            if (typeof s !== 'string') {
                return ''
            }
            let r = s.toLowerCase()

            r = r.replace(/\s/g, '')
            r = r.replace(/[àáâãäå]/g, 'a')
            r = r.replace(/æ/g, 'ae')
            r = r.replace(/ç/g, 'c')
            r = r.replace(/[èéêë]/g, 'e')
            r = r.replace(/[ìíîï]/g, 'i')
            r = r.replace(/ñ/g, 'n')
            r = r.replace(/[òóôõö]/g, 'o')
            r = r.replace(/œ/g, 'oe')
            r = r.replace(/[ùúûü]/g, 'u')
            r = r.replace(/[ýÿ]/g, 'y')
            r = r.replace(/\W/g, '')

            return r
        },

        updatePaginator() {
            const totalItems = this.filterList.length
            this.paginator.showPreviousButton = this.paginator.currentPage > 1
            this.paginator.showNextButton =
                totalItems > this.paginator.currentPage * this.paginator.pageSize
        },

        nextPage() {
            if (this.paginator.currentPage < this.totalPages) {
                this.paginator.currentPage++
                this.updatePaginator()
            }
        },

        previousPage() {
            if (this.paginator.currentPage > 1) {
                this.paginator.currentPage--
                this.updatePaginator()
            }
        },
    },
    computed: {
        filterList() {
            const normalizedSearch = this.normalize(this.strSearch);
            return this.detenteurs.filter((det) => {
                const normalizedRaisonSociale = this.normalize(det.raison_sociale);
                const normalizedVille = this.normalize(det.ville);
                const normalizedCodeClient = det.hasOwnProperty('code_client') && det.code_client !== null ? this.normalize(det.code_client) : '';
                const normalizedAdresse = this.normalize(det.adresse);
                const normalizedCodePostal = this.normalize(det.code_postal);
                const normalizedCustom = det.hasOwnProperty('custom') && det.custom !== null ? this.normalize(det.custom) : '';

                return (
                    normalizedRaisonSociale.includes(normalizedSearch) ||
                    normalizedVille.includes(normalizedSearch) ||
                    normalizedCodeClient.includes(normalizedSearch) ||
                    normalizedAdresse.includes(normalizedSearch) ||
                    normalizedCodePostal.includes(normalizedSearch) ||
                    normalizedCustom.includes(normalizedSearch)
                );
            });
        },

        paginatedList() {
            const start = (this.paginator.currentPage - 1) * this.paginator.pageSize
            const end = start + this.paginator.pageSize
            return this.filterList.slice(start, end)
        },

        totalPages() {
            return Math.ceil(this.filterList.length / this.paginator.pageSize)
        },
    },
    mounted() {
        window.addEventListener('localStorageAsyncDetenteurs', () => {
            this.asyncDetenteurs = localStorage.getItem('asyncDetenteurs') === 'true'
        })
        this.fetchDetenteurs()
        History.clearHistory('installation');
    },
    components: {
        DetenteurItem,
    },
}
</script>
<style>
.infoAsync {
    background-color: #eee;
    padding: 10px 0;
    margin-bottom: 10px;
    text-align: center;
    display: flex;
    justify-content: center;
    /* Centrer horizontalement */
    align-items: center;
    /* Aligner verticalement */
}

.infoAsync p {
    display: flex;
    align-items: center;
    /* Aligner verticalement le contenu du paragraphe */
    margin: 0;
    /* Supprimer les marges par défaut du paragraphe */
}

.spinner-load {
    width: 50px;
    height: 50px;
    margin-right: 10px;
    /* Ajouter de l'espace entre l'image et le texte */
}

.list-item {
    list-style: none !important;
    /* au cas où il hérite d’un style de liste */
}
</style>



// WEBPACK FOOTER //
// ListeDetenteurs.vue?1d00aac5